<template>
  <div class="home-page login-content" style="padding-top: 0;">
    <Header></Header>
    <div class="login login-send">
      <div class="home-prize ac">
        <img style="width: 70%" src="../../static/images/login_tip.png"/>
      </div>
      <div class="landing-page">
        <div class="input-div">
          <div class="span mt20 fs33 fw7" style="font-weight: 800;margin-bottom: 15px;color: white">
            {{ $t('loginTips') }}
          </div>
          <div class="input-item mt20">
            <div class="input-item2">
              <span class="app-en num_09"></span>
              <input style="height: 100px;color: black;font-size: 55px" class="input" v-model="mobile" type="number" placeholder="">
            </div>
          </div>
        </div>

        <div class="ac " style="margin-top: 40px">
          <div class="drown-list login-list" style="width: 100%">
            <div class="disflex" style="background:none;box-shadow: none;">
              <div style="width: 50%"  class="land-btn day_btn" @click="checkUserStatus()">
                <span class="day">{{ $t('Login') }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="ac otp-b disflex mt100">
          <div style="color: white" class="icon icon2 fw7" @click="getToNav('termsAndCondition')">{{ $t('TC') }} <span
            class="app-en">>></span></div>
          <div style="color: white" class="icon icon2 fw7" @click="getToNav('faq')">{{ $t('FAQ') }} <span
            class="app-en">>></span></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import Header from '../components/HeaderTwo'
import CryptoJS from '../../static/js/crypto-js.min.js'
export default {
  components: {
    Header
  },
  data() {
    return {
      list: [],
      mobile: '',
      type: ''
    }
  },
  created() {
    if (localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
    if (this.$route.query.msidn) {
      let ss = this.aesEcbDecrypt(this.$route.query.msidn);
      this.mobile = this.dealPhone_2(ss);
    }
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    //渠道是atomber 且 有号码的
    let channelId = this.$route.query.channelId;
    if (channelId == 'atomber' && this.mobile){
      //查询订阅状态 直接到otp 订阅页面
      this.checkUserStatus();
    }
  },
  methods: {
    checkUserStatus() {
      let that = this
      if (that.mobile == '') {
        that.$utils.alertText(that.$t('loginTips'), 60)
        return;
      }
      let mobile = '09' + that.mobile
      mobile = that.dealPhone(mobile)
      const userAgent = navigator.userAgent;
      const deviceId = this.getDeviceId();
      let encrypt_mobile = that.aesEcbEncrypt(mobile);
      let data = {
        msidn:encrypt_mobile,
        user_agent: userAgent,
        device_id: deviceId
      }
      that.$parent.loadModal(true);
      that.$api.post('/api/user/user_status', data, r => {
        that.$parent.loadModal(false);
        that.$parent.returnCode(r, function () {
          if (r.code == 0) {
            that.$utils.alertText(r.msg, 80);
          } else {
            if (r.data.status == 1 || r.data.status == -2) {
              if (r.data.change_device) {
                that.goOtpLogin();
                return;
              } else {
                that.goLogin();
                return;
              }
            }
            that.goSub();
          }
        })
      })
    },
    getToNav(url) {
      this.$router.push({path: '/' + url});
    },
    dealPhone_2(phone) {
      phone = phone.replace(/\s+/g, ''); // 移除所有空格
      if (phone.startsWith('97') && phone.length === 10) {
        phone = phone.substring(1);
      }
      return phone;
    },
    dealPhone(phone) {
      phone = phone.replace(/\s+/g, ''); // 移除所有空格
      if (phone.startsWith('0909') && phone.length === 13) {
        phone = phone.substring(3);
      }
      if (phone.startsWith('09') && phone.length === 11) {
        phone = phone.substring(1);
      }
      if (phone.startsWith('099') && phone.length === 12) {
        phone = phone.substring(2);
      }
      return phone;
    },
    getDeviceId() {
      let id = localStorage.getItem('device_id');
      if (!id) {
        id = 'dev-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
        localStorage.setItem('device_id', id);
      }
      return id;
    },
    goLogin(){
      let that = this;
      that.$parent.loadModal(true);
      if (that.mobile === ""){
        that.$utils.alertText(that.$t('loginTips'), 60)
        that.$parent.loadModal(false);
        return
      }
      let mobile = that.dealPhone('09' + this.mobile)
      let encrypt_mobile = that.aesEcbEncrypt(mobile);
      let data = {
        msidn:encrypt_mobile
      }
      that.$api.post('/api/user/login',data,r =>{
        that.$parent.loadModal(false);
        if(r.code==1){
          localStorage.setItem('token',r.data.userinfo.token)
          localStorage.setItem('mobile',r.data.userinfo.mobile)
          this.$router.push({path:'/'})
        }else{
          that.$utils.alertText(r.msg,80);
        }
      })
    },
    goOtpLogin(){
      let mobile = this.dealPhone('09' + this.mobile)
      let encrypt_mobile = this.aesEcbEncrypt(mobile);
      this.$router.push({path:'/otp',query: {msidn:encrypt_mobile}});
    },
    goSub() {
      let mobile = this.dealPhone('09' + this.mobile)
      let encrypt_mobile = this.aesEcbEncrypt(mobile);
      let query = Object.assign({}, this.$route.query, {
        msidn: encrypt_mobile
      });
      delete query.mobile;
      this.$router.push({path:'/sub', query});
    },
    //解密
    aesEcbDecrypt(ciphertextBase64) {
      try {
        const key = CryptoJS.enc.Utf8.parse("jksdfuiAa4so1ewm");
        const encrypted = CryptoJS.enc.Base64.parse(ciphertextBase64);
        const decrypted = CryptoJS.AES.decrypt(
          { ciphertext: encrypted },
          key,
          {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.NoPadding
          }
        );
        return decrypted.toString(CryptoJS.enc.Utf8).replace(/\0+$/, "");
      } catch (e) {
        console.error("AES 解密失败:", e);
        return "";
      }
    },
    //加密
    aesEcbEncrypt(plaintext) {
      var key = CryptoJS.enc.Utf8.parse("jksdfuiAa4so1ewm");
      var data = CryptoJS.enc.Utf8.parse(plaintext);
      var blockSize = 16;
      var padLen = (blockSize - (data.sigBytes % blockSize)) % blockSize;
      var words = data.words.slice(0);
      var wordArray = CryptoJS.lib.WordArray.create(words, data.sigBytes + padLen);
      var encrypted = CryptoJS.AES.encrypt(wordArray, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.NoPadding
      });
      return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    },

  }
}
</script>
<style scoped>
.drop-down-content {
  z-index: 9;
  background: none;
}

.mt100 {
  margin-top: 100px;
}

.otp-b {
  justify-content: space-evenly;
}

.login-list .drown-li {
  min-width: 320px;
}

.login-list .drown-li + .drown-li {
  margin-left: 30px;
}

.login-list .drown-li + .drown-li .disflex {
  background: #0065f3;
}
</style>



// WEBPACK FOOTER //
// src/page/Login.vue